import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-product-resources',
  templateUrl: './product-resources.component.html',
  styleUrls: ['./product-resources.component.scss'],
  standalone: true,
  imports: [NgFor]
})
export class ProductResourcesComponent {
  commonImagePath: string = environment.commonImagePath;
  cdnImagePath: string = environment.cdnImagePath;
  @Input() productResourcesData: any;
}